/**
 * Update flash: a row flashes for 500 ms when its displayed value changes
 * (the previous .value-updated class). The pure part compares two snapshots;
 * the hook tracks one value.
 */
import { useEffect, useRef, useState } from 'react';

export const FLASH_MS = 500;

/** Keys whose value differs between two snapshots, plus keys new in `next`; removed keys do not flash. */
export function changedKeys(prev: Record<string, string>, next: Record<string, string>): string[] {
  const out: string[] = [];
  for (const key of Object.keys(next)) if (prev[key] !== next[key]) out.push(key);
  return out;
}

/** True for FLASH_MS after `value` changes; never true on first render. */
export function useFlash(value: string, ms: number = FLASH_MS): boolean {
  const prev = useRef(value);
  const [flashing, setFlashing] = useState(false);
  useEffect(() => {
    if (prev.current === value) return;
    prev.current = value;
    setFlashing(true);
    const timer = window.setTimeout(() => setFlashing(false), ms);
    return () => window.clearTimeout(timer);
  }, [value, ms]);
  return flashing;
}
